import { useEffect, useRef, useState } from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';
import './style/ZoomSliderControl.css';

const ZoomSliderControl = () => {
  const map = useMap();
  const [zoom, setZoom] = useState(map.getZoom());
  const sliderRef = useRef();
  const containerRef = useRef();

  const minZoom = map.getMinZoom();
  const maxZoom = map.getMaxZoom();

  useEffect(() => {
    const updateZoom = () => setZoom(map.getZoom());
    map.on('zoomend', updateZoom);

    return () => {
      map.off('zoomend', updateZoom);
    };
  }, [map]);

  // Controla nível de zoom
  useEffect(() => {
    const container = map.getContainer();
    const onWheel = (e) => {
      e.preventDefault(); 
      const delta = e.deltaY; 

      if (delta > 0) {
        map.setZoom(map.getZoom() - 0.3);
      } 
      else {
        map.setZoom(map.getZoom() + 0.3);
      }
    };

    container.addEventListener('wheel', onWheel, { passive: false });
    return () => {
      container.removeEventListener('wheel', onWheel);
    };
  }, [map]);

  useEffect(() => {
    const container = containerRef.current;
    const slider = sliderRef.current;
    if (!container || !slider) return;

    L.DomEvent.disableClickPropagation(container);
    L.DomEvent.disableScrollPropagation(container);

    const disableMapDragging = () => map.dragging.disable();
    const enableMapDragging = () => map.dragging.enable();

    slider.addEventListener('mousedown', disableMapDragging);
    slider.addEventListener('mouseup', enableMapDragging);
    slider.addEventListener('mouseleave', enableMapDragging);
    slider.addEventListener('touchstart', disableMapDragging);
    slider.addEventListener('touchend', enableMapDragging);
    slider.addEventListener('touchcancel', enableMapDragging);

    return () => {
      slider.removeEventListener('mousedown', disableMapDragging);
      slider.removeEventListener('mouseup', enableMapDragging);
      slider.removeEventListener('mouseleave', enableMapDragging);
      slider.removeEventListener('touchstart', disableMapDragging);
      slider.removeEventListener('touchend', enableMapDragging);
      slider.removeEventListener('touchcancel', enableMapDragging);
    };
  }, [map]);

  const handleChange = (e) => {
    const newZoom = Number(e.target.value);
    setZoom(newZoom);
    map.setZoom(newZoom, { animate: true });
  };

  return (
    <div className="zoom-slider-control" ref={containerRef}>
      <button onClick={() => map.zoomOut()}>−</button>
      <input
        ref={sliderRef}
        type="range"
        min={minZoom}
        max={maxZoom}
        value={zoom}
        step="0.5"
        onChange={handleChange}
      />
      <button onClick={() => map.zoomIn()}>+</button>
    </div>
  );
};

export default ZoomSliderControl;